var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCheckPink = function SvgIconCheckPink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 28 28"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m19.793 17.057-.03.033-5.858 5.935a1.03 1.03 0 0 1-1.468 0 1.06 1.06 0 0 1-.03-1.455l.03-.032 5.136-5.205-9.802-9.87a1.06 1.06 0 0 1 0-1.488c.395-.4 1.029-.41 1.436-.031l.032.03 10.524 10.603c.197.2.299.46.304.723v.066a1.06 1.06 0 0 1-.24.652l-.034.04Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#DA1B85"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 2,
    transform: "rotate(90 13.767 14)"
  }))));
};
export { SvgIconCheckPink as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgMjggMjgiPjxkZWZzPjxwYXRoIGlkPSJhIiBkPSJtMTkuNzkzIDE3LjA1Ny0uMDMuMDMzLTUuODU4IDUuOTM1Yy0uNDA1LjQxMS0xLjA2Mi40MTEtMS40NjggMGExLjA2MiAxLjA2MiAwIDAgMS0uMDMtMS40NTVsLjAzLS4wMzIgNS4xMzYtNS4yMDUtOS44MDItOS44N2ExLjA2MiAxLjA2MiAwIDAgMSAwLTEuNDg4Yy4zOTUtLjQgMS4wMjktLjQxIDEuNDM2LS4wMzFsLjAzMi4wMyAxMC41MjQgMTAuNjAzYy4xOTcuMi4yOTkuNDYuMzA0LjcyM3YuMDY2YTEuMDU3IDEuMDU3IDAgMCAxLS4yNC42NTJsLS4wMzQuMDRaIi8+PC9kZWZzPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PGNpcmNsZSBjeD0iMTQiIGN5PSIxNCIgcj0iMTQiIGZpbGw9IiNEQTFCODUiLz48dXNlIHhsaW5rOmhyZWY9IiNhIiBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9Im5vbnplcm8iIHN0cm9rZT0iI0ZGRiIgc3Ryb2tlLXdpZHRoPSIyIiB0cmFuc2Zvcm09InJvdGF0ZSg5MCAxMy43NjcgMTQpIi8+PC9nPjwvc3ZnPg==";